// src/contracts/constants.js

export const CASHISDEAD_ADDRESS =
  process.env.REACT_APP_CASHISDEAD_CONTRACT_ADDRESS ||
  '0xA57ED06Ca426Fee4eBB748Eda7df5814e14990C8';
export const CASHSTAKING_ADDRESS = '0x5F7024108fc11e48F7bb8dc35Abe0CA9339fb31B';
export const CASHSWAP_ADDRESS = '0xcfA57DEFa9a4E109E20E2accBE741968C265A5B6';
export const CASHMINING_ADDRESS = '0x1F7511cD1E3036D904Be5A1764478D4d2f79bb17';
export const CASHNFT_ADDRESS = '0x47F3da54393843Be3b9DDe06f74B6a5e282BE8DF';
export const LPCASHSTAKE_ADDRESS = '0x2EC499355B9fC51df88777A716ba1C9998ac03c0';
export const BOOSTERNFT_ADDRESS = '0x078c418Ae8EBf76DBf43e6b696E1C6A1e74D3AC0';
export const LPTOKEN_ADDRESS = '0x943e6e07a7E8E791dAFC44083e54041D743C46E9';

export const NETWORK_CONFIG = {
  chainId: 130,
  chainIdHex: '0x82',
  name: 'Unichain',
  // Use your private Alchemy RPC URL from .env:
  rpcUrl: process.env.REACT_APP_ALCHEMY_RPC_URL || 'https://mainnet.unichain.org',
  blockExplorer: 'https://unichainexplorer.chaineye.tools/',
  bridgeUrl: 'https://superbridge.app/unichain',
  nativeCurrency: {
    name: 'ETH',
    symbol: 'ETH',
    decimals: 18,
  },
};

export const UNISWAP_QUOTER_ADDRESS = "0x385a5cf5f83e99f7bb2852b6a19c3538b9fa7658";
export const WETH9_ADDRESS =
  process.env.REACT_APP_UNICHAIN_WETH9_ADDRESS || '0x4200000000000000000000000000000000000006';

export const DEBUG_MODE = false;